/**
 * SELECTION CARD TOKENS
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createSelectionCardTokens(s: SemanticTokens) {
  return {
    /** Base spacing for selection cards */
    base: {
      paddingX: v('selection-card.base.padding-x'), // --selection-card-base-padding-x: var(--spacing-8)
      paddingY: v('selection-card.base.padding-y'), // --selection-card-base-padding-y: var(--spacing-8)
      gap: v('selection-card.base.gap'), // --selection-card-base-gap: var(--spacing-8)
      radius: v('selection-card.base.radius'), // --selection-card-base-radius: var(--radius-8)
    },
    bgDefault: v('selection-card.item.bg-default'), // --selection-card-item-bg-default: var(--surface-ground)
    bgHover: s.surface.raised, // --selection-card-item-bg-hover: var(--surface-raised)
    bgPressed: s.interactive.secondary.subtleHover, // --selection-card-item-bg-pressed: var(--color-rentsody-100)
    bgActive: v('selection-card.item.bg-active'), // --selection-card-item-bg-active: var(--color-rentsody-50)
    bgDisabled: s.surface.disabled, // --selection-card-item-bg-disabled: var(--surface-disabled)
    fgDefault: v('selection-card.item.fg-default'), // --selection-card-item-fg-default: var(--text-secondary)
    fgHover: s.text.secondary, // --selection-card-item-fg-hover: var(--text-secondary)
    fgPressed: s.text.secondary, // --selection-card-item-fg-pressed: var(--text-secondary)
    fgActive: v('selection-card.item.fg-active'), // --selection-card-item-fg-active: var(--text-secondary)
    fgDisabled: s.text.secondary, // --selection-card-item-fg-disabled: var(--text-secondary)
    border: v('selection-card.item.border'), // --selection-card-item-border: var(--border-default)
  };
}
export const selectionCardTokens = createSelectionCardTokens(SEMANTIC);
